import BToast from './toast';
import BToaster from './toaster';
import BVToastPlugin from './helpers/bv-toast';
import { installFactory } from '../../utils/plugins';
var components = {
  BToast: BToast,
  BToaster: BToaster
};
var plugins = {
  // $bvToast injection
  BVToastPlugin: BVToastPlugin
};
export { BToast, BToaster };
export default {
  install: installFactory({
    components: components,
    plugins: plugins
  })
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/toast/index.js
// module id = weWj
// module chunks = 0